import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { defaultDoc } from '../share/defaultDoc';
import type { RemedialAction } from './remedialAction.types';

export const remedialActionPullQueryBuilder = (document: RemedialAction) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query remedialActionFeed($lastRequested: DateTime) {
      remedialActionFeed(lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified },
  };
};
